<template>
  <card>
    <list
      v-if="$store.state.user.sections['prices']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :filters="filters"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      filters: [
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey: "name",
          field_key: "shop",
          selectKey: "name",
        },
      ],
      params: {},
      val: [],
      modalCreate: "price",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "variant",
          label: "Товар",
          type: "select",
          modal: "variant",
          selectKey: "name",
          params: { show: 1 },
        },
        {
          col: " col-12 col-md-12",
          key: "shop",
          label: "Магазин",
          type: "select",
          modal: "shop",
          selectKey: "name",
        },
        {
          col: " col-12 col-md-7",
          key: "price",
          label: "Цена",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-5",
          key: "quantity",
          label: "Количество",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "prices",
      setLink: "prices",
      columns: [
        {
          key: "variant",
          object: "name",
          title: "Товар",
          checkbox: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "variant",
          object: "barcode",
          title: "Баркод",
          checkbox: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "shop",
          object: "name",
          title: "Магазин",
          checkbox: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price",
          title: "Цена",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          price: true,
        },
        {
          key: "quantity",
          title: "Количество",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "reason",
          title: "Причина",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "user",
          title: "Отвественный",
          object: "name",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "order",
          title: "Заказ",
          disableLink: false,
          object: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "",
          dateTimeFormat: true,
          control: false,
          align: "right",
          timer: false,
          detail: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
